import React, { Component, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import store from "../../helpers/store/Store";
import {
  updateAdditionalTabs,
  updateDynaPropValues,
  updateSelectedPropValues,
  updateSelectedSchedule,
} from "../../helpers/actions/Action";
import ValveSchedule from "./schedules/ValveSchedule";
const MetaPropertiesPropValueList = () => {
  const dynaPropValues = useSelector(
    (state) => state.metaPropReducer.dynaPropValues
  );
  const statPropValues = useSelector(
    (state) => state.metaPropReducer.statPropValues
  );
  const elemWithProperties = useSelector(
    (state) => state.metaPropReducer.elementWithProperties
  );
  const categories = useSelector((state) => state.metaPropReducer.categories);
  const selectedModel = useSelector(
    (state) => state.getSelectedModelReducer.data
  );
  const elemTagsCatsList = useSelector(
    (state) => state.metaPropReducer.elemTagsCatsList
  );
  const selectedPropValues = useSelector(
    (state) => state.metaPropReducer.selectedPropValues
  );
  const showMetaPropTagList = useSelector(
    (state) => state.metaPropReducer.showMetaPropTagList
  );

  const dispatch = useDispatch();

  // componentDidUpdate() {
  //   // if (this.state.selectedPropValues !== this.props.selectedPropValues) {
  //   //   this.setState({
  //   //     selectedPropValues: this.props.selectedPropValues,
  //   //   });
  //   // }

  //   this.saveTabData();
  // }

  useEffect(() => {
    saveTabData();
  }, []);

  const saveTabData = () => {
    var tabData = {
      ElemWithProps: JSON.stringify(elemWithProperties),
      Categories: JSON.stringify(categories),
      DynaPropValues: JSON.stringify(dynaPropValues),
      StatPropValues: JSON.stringify(statPropValues),
    };

    const tabSize =
      tabData.ElemWithProps.length +
      tabData.Categories.length +
      tabData.DynaPropValues.length +
      tabData.StatPropValues.length;

    // console.log("tabSize", tabSize);
    if (tabSize > 4700000) {
      store.dispatch(updateAdditionalTabs(false));
    } else {
      //redux state to change tab possible to true
      store.dispatch(updateAdditionalTabs(true));
      window.sessionStorage.setItem(
        selectedModel.fileName,
        JSON.stringify(tabData)
      );
    }
  };

  const handleInputValueChange = (elem) => {
    var tempSelectedPropValues = selectedPropValues.map((selectedPropValue) => {
      if (selectedPropValue.propName === elem.target.name) {
        console.log("--------1--------------");
        return {
          propName: selectedPropValue.propName,
          propValue: elem.target.value,
        };
      } else {
        return selectedPropValue;
      }
    });
    // var tempDynaPropValues = dynaPropValues;

    // elemTagsCatsList.forEach((elemTagCat) => {
    //   console.log("--------2--------------");
    //   for (var i = 0; i < tempDynaPropValues.length; i++) {
    //     if (tempDynaPropValues[i].tag === elemTagCat.tag) {
    //       for (var j = 0; j < tempDynaPropValues[i].propValueList.length; j++) {
    //         for (var k = 0; k < selectedPropValues.length; k++) {
    //           if (
    //             tempDynaPropValues[i].propValueList[j].propName ==
    //             selectedPropValues[k].propName
    //           ) {
    //             tempDynaPropValues[i].propValueList[j].propValue =
    //               selectedPropValues[k].propValue;
    //             break;
    //           }
    //         }
    //       }
    //       break;
    //     }
    //   }
    // });
    console.log("temp selected prop values", tempSelectedPropValues);
    dispatch(updateSelectedPropValues([...tempSelectedPropValues]));

    // console.log("DYNAPROP CHANGED", tempDynaPropValues);
    // dispatch(updateDynaPropValues(updateDynaPropValuesStore()));
    // console.log("Value from function =", updateDynaPropValuesStore());

    updateDynaPropValuesStore(tempSelectedPropValues);
  };

  // const updateDynaPropValuesStore = () => {
  //   var tempDynaPropValues = [...dynaPropValues];

  //   elemTagsCatsList.forEach((elemTagCat) => {
  //     for (var i = 0; i < tempDynaPropValues.length; i++) {
  //       if (tempDynaPropValues[i].tag === elemTagCat.tag) {
  //         for (var j = 0; j < tempDynaPropValues[i].propValueList.length; j++) {
  //           for (var k = 0; k < selectedPropValues.length; k++) {
  //             if (
  //               tempDynaPropValues[i].propValueList[j].propName ==
  //               selectedPropValues[k].propName
  //             ) {
  //               tempDynaPropValues[i].propValueList[j].propValue =
  //                 selectedPropValues[k].propValue;
  //               break;
  //             }
  //           }
  //         }
  //         break;
  //       }
  //     }
  //   });
  //   return tempDynaPropValues;
  // };
  const updateDynaPropValuesStore = (tempselectedpropvalues) => {
    let tempDynaPropValues = [...dynaPropValues];
    console.log("selectedPropValues =", selectedPropValues);
    console.log("tempSelectedpropValues =", tempselectedpropvalues);

    elemTagsCatsList.forEach((elemTagCat) => {
      for (var i = 0; i < tempDynaPropValues.length; i++) {
        console.log("elemTagCat =", elemTagCat);
        if (tempDynaPropValues[i].tag === elemTagCat.tag) {
          if (elemTagCat.isSelected) {
            for (
              var j = 0;
              j < tempDynaPropValues[i].propValueList.length;
              j++
            ) {
              for (var k = 0; k < tempselectedpropvalues.length; k++) {
                if (
                  tempDynaPropValues[i].propValueList[j].propName ===
                  tempselectedpropvalues[k].propName
                ) {
                  tempDynaPropValues[i].propValueList[j].propValue =
                    tempselectedpropvalues[k].propValue;
                  break;
                }
              }
            }
            break;
          }
        }
      }
      console.log("DYNAPROP CHANGED", tempDynaPropValues);
      dispatch(updateDynaPropValues(tempDynaPropValues));
    });
  };

  // render() {
  return (
    <div>
      {console.log("showmetaproptaglist =", showMetaPropTagList)}
      {showMetaPropTagList ? (
        <>
          <div className="row justify-content-center align-items-center">
            <h3>Property Table</h3>
          </div>
          <table className="table table-sm ">
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>Property</th>
                <th style={{ textAlign: "center" }}>Value</th>
              </tr>
            </thead>
            <tbody>
              {selectedPropValues.map((selectedPropValue, index) => {
                console.log("dynapropvalues", dynaPropValues);
                return (
                  <tr id={"prop-value-list-row" + index}>
                    <td style={{ textAlign: "center", alignItems: "center" }}>
                      {selectedPropValue.propName}
                    </td>
                    <td style={{ textAlign: "center", alignItems: "center" }}>
                      <div
                        className="col-8 p-0"
                        style={{ textAlign: "center", alignItems: "center" }}
                      >
                        <input
                          className="form-control"
                          type="text"
                          name={selectedPropValue.propName}
                          value={selectedPropValue.propValue}
                          placeholder="Enter Value"
                          id={selectedPropValue.propName}
                          onChange={handleInputValueChange}
                          style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
// }

// const mapStateToProps = (state) => ({
//   dynaPropValues: state.metaPropReducer.dynaPropValues,
//   statPropValues: state.metaPropReducer.statPropValues,
//   elemWithProperties: state.metaPropReducer.elementWithProperties,
//   categories: state.metaPropReducer.categories,
//   selectedModel: state.getSelectedModelReducer.data,
//   elemTagsCatsList: state.metaPropReducer.elemTagsCatsList,
//   selectedPropValues: state.metaPropReducer.selectedPropValues,
// });

// export default connect(mapStateToProps)(MetaPropertiesPropValueList);
export default MetaPropertiesPropValueList;
